import AvgCheckSize from './AvgCheckSize';
export default AvgCheckSize;